import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { triageApi } from '../api/triageApi';
import type { TriageListFilters } from '../api/types';

export function useTriageList(filters?: TriageListFilters) {
  return useQuery({
    queryKey: keys.triage.list(filters),
    queryFn: ({ signal }) => triageApi.getList(filters, { signal }),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
